import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { setClickedMerchantFeatures } from 'src/RootRedux/UrlRedux/Actions'

import { setShopeeAppClicked } from 'src/Common/Components/MenuSelectionBar/Redux/Actions/index.js'

import {
  shopeeLogoVn,
  QRVn,
  footerLeftUpperTitleVn,
  footerRightUpperTitleVn,
  leftBoxLinksVn,
  rightBoxLinksVn,
  address,
  companyName,
  paymentServicesIntro,
  paymentServices
} from './Constants/Constants'

import './style.less'
import { Body1, Footnote } from 'src/Common/Theme/Typography'
import { isDesktop } from 'isDesktop'
import { REGIONS } from 'src/Services/RegionGetter/Constants'
import { setSelectionMenu } from '../MenuSelectionBar/Redux/Actions'
import { left, right } from '../MenuSelectionBar/Constants'
import logo from 'src/Common/Assets/Icons/ShopeeLogo/shopeePayLogo.svg'
import verifiedLabel from './Assets/Icons/Vn/verified-label.png'
import { ConsentPagePath } from 'src/Navigation'

export const AppFooter = () => {
  const location = useLocation()
  const { pathname } = location
  const isConsentPage = pathname === ConsentPagePath

  const dispatch = useDispatch()
  // reducer
  const regionLanguage = useSelector((state) => state.RegionLanguageReducer)
  const { region, language } = regionLanguage

  // state
  const [footerLeftUpperTitle, setFooterLeftUpperTitle] = useState('')
  const [footerRightUpperTitle, setFooterRightUpperTitle] = useState('')

  const [leftBoxLinks, setLeftBoxLinks] = useState([])
  const [rightBoxLinks, setRightBoxLinks] = useState([])

  const [shopeeLogo, setShopeeLogo] = useState('')
  const [QR, setQR] = useState([])

  // effect
  useEffect(() => {
    switch (true) {
      case language === REGIONS.vietnam:
        setFooterLeftUpperTitle(footerLeftUpperTitleVn)
        setFooterRightUpperTitle(footerRightUpperTitleVn)
        setLeftBoxLinks(leftBoxLinksVn)
        setRightBoxLinks(rightBoxLinksVn)
        setShopeeLogo(shopeeLogoVn)
        setQR(QRVn)

        break
      default:
    }
  }, [language, region])

  // for color change of header
  const onButtonClick = (path) => {
    if (path === '/doi-tac') {
      dispatch(setClickedMerchantFeatures(true))
    } else if (path === '/tinh-nang/#App') {
      dispatch(setSelectionMenu(right))
    } else if (path === '/tinh-nang') {
      dispatch(setSelectionMenu(left))
    } else if (
      path === '/chinh-sach-bao-mat' ||
      path === '/dieu-khoan-su-dung' ||
      path === '/lien-he-chung-toi'
    ) {
      dispatch(setClickedMerchantFeatures(false))
    } else {
      dispatch(setClickedMerchantFeatures(false))
    }
  }

  if (isConsentPage) return <></>

  return (
    <>
      {/* for screen size above 600px */}
      {isDesktop() ? (
        <div className="AppFooter">
          <div className="AppFooter__Wrapper">
            <div className="AppFooter__WidthContainer">
              <div className="AppFooter__LeftBox">
                <img className="AppFooter__LeftBox__logo" src={logo} alt="" />
                <div className="address">
                  <div className="AppFooter__LeftBox__companyNameRow">
                    <Footnote>{companyName}</Footnote>
                    <a
                      href="http://online.gov.vn/nen-tang/c4c115a7-0e54-4d6a-b607-73ae719039ff"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Đã xác nhận với Bộ Công Thương"
                    >
                      <img
                        src={verifiedLabel}
                        alt="Đã thông báo Bộ Công Thương"
                        className="AppFooter__LeftBox__verifiedLabel"
                      />
                    </a>
                  </div>
                  <Footnote>{address}</Footnote>
                  <Footnote>{paymentServicesIntro}</Footnote>
                  {paymentServices.map((service, index) => (
                    <Footnote key={index}>{service}</Footnote>
                  ))}
                </div>
              </div>
              <div className="AppFooter__RightBox">
                <div className="AppFooter__RightUpperBox">
                  <div className="AppFooter__RightUpperBox__termsTitle">
                    {footerLeftUpperTitle}
                  </div>
                  <div className="AppFooter__RightUpperBox__termsTitle">
                    {footerRightUpperTitle}
                  </div>
                  <div>
                    <Body1>
                      <Link
                        to="/doi-tac"
                        className="AppFooter__RightUpperBox__Link"
                        onClick={() => {
                          window.scrollTo({
                            top: 720,
                            left: 0
                          })
                          onButtonClick('/doi-tac')
                          dispatch(setShopeeAppClicked(false))
                        }}
                      >
                        {leftBoxLinks.merchantFeatures}
                      </Link>
                    </Body1>
                    <Body1>
                      <Link
                        to="/khuyen-mai"
                        className="AppFooter__RightUpperBox__Link"
                        onClick={() => {
                          window.scrollTo({
                            top: 0,
                            left: 0
                          })
                          onButtonClick('/khuyen-mai')
                          dispatch(setShopeeAppClicked(false))
                        }}
                      >
                        {leftBoxLinks.promo}
                      </Link>
                    </Body1>
                  </div>
                  <div>
                    <Link
                      className="AppFooter__RightUpperBox__Link"
                      to="/dieu-khoan-su-dung"
                      onClick={() => {
                        window.scrollTo(0, 0)
                        onButtonClick('/dieu-khoan-su-dung')
                        dispatch(setShopeeAppClicked(false))
                      }}
                    >
                      {rightBoxLinks.termsConditions}
                    </Link>
                    <Link
                      className="AppFooter__RightUpperBox__Link"
                      to="/chinh-sach-bao-mat"
                      onClick={() => {
                        window.scrollTo(0, 0)
                        onButtonClick('/chinh-sach-bao-mat')
                        dispatch(setShopeeAppClicked(false))
                      }}
                    >
                      {rightBoxLinks.PrivacyPolicy}
                    </Link>
                    <Link
                      className="AppFooter__RightUpperBox__Link"
                      to="/spaylater-dieu-khoan-su-dung"
                      onClick={() => {
                        window.scrollTo(0, 0)
                        onButtonClick('/spaylater-dieu-khoan-su-dung')
                        dispatch(setShopeeAppClicked(false))
                      }}
                      style={{ marginTop: '15px' }}
                    >
                      {rightBoxLinks.SPLTermsConditions}
                    </Link>
                    <Link
                      className="AppFooter__RightUpperBox__Link"
                      to="/ung-tien-ngay-dieu-khoan-va-dieu-kien"
                      onClick={() => {
                        window.scrollTo(0, 0)
                        onButtonClick(
                          '/ung-tien-ngay-dieu-khoan-va-dieu-kien'
                        )
                        dispatch(setShopeeAppClicked(false))
                      }}
                      style={{ marginTop: '15px' }}
                    >
                      {rightBoxLinks.CashAdvanceTermsConditions}
                    </Link>
                    <Link
                      className="AppFooter__RightUpperBox__Link"
                      to="/seasy-vay-tien-nhanh-dieu-khoan-su-dung"
                      onClick={() => {
                        window.scrollTo(0, 0)
                        onButtonClick(
                          '/seasy-vay-tien-nhanh-dieu-khoan-su-dung'
                        )
                        dispatch(setShopeeAppClicked(false))
                      }}
                      style={{ marginTop: '15px' }}
                    >
                      {rightBoxLinks.SEasyBuyerLoanTermsConditions}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="AppFooterMobile">
          <div className="AppFooterMobile__TopBox">
            <img className="AppFooterMobile__TopBox__logo" src={logo} alt="" />
          </div>
          <div className="AppFooterMobile__MiddleUpperBox">
            <div className="AppFooterMobile__MiddleUpperBox__termsTitle">
              {footerLeftUpperTitle}
            </div>

            <p>
              <Link
                to="/doi-tac/#merchantApp"
                style={{ textDecoration: 'none', color: '#000000' }}
                onClick={() => {
                  window.scrollTo({
                    top: 480,
                    left: 0
                  })
                  onButtonClick('/merchant')
                  dispatch(setShopeeAppClicked(false))
                }}
              >
                <Body1 className="AppFooterMobile__MiddleUpperBox__itemNavMobile">
                  {leftBoxLinks.merchantFeatures}
                </Body1>
              </Link>
            </p>
            {region !== REGIONS.malaysia && (
              <p>
                <Link
                  to="/khuyen-mai"
                  className="itemNav"
                  onClick={() => {
                    window.scrollTo({
                      top: 480,
                      left: 0
                    })
                    onButtonClick('/khuyen-mai')
                    dispatch(setShopeeAppClicked(false))
                  }}
                >
                  <Body1 className="AppFooterMobile__MiddleUpperBox__itemNavMobile">
                    {leftBoxLinks.promo}
                  </Body1>
                </Link>
              </p>
            )}

            <div className="AppFooterMobile__MiddleUpperBox__termsTitle">
              {footerRightUpperTitle}
            </div>
            <div>
              <p>
                <Link
                  to="/dieu-khoan-su-dung"
                  onClick={() => {
                    window.scrollTo(0, 0)
                    onButtonClick('/dieu-khoan-su-dung')
                    dispatch(setShopeeAppClicked(false))
                  }}
                >
                  <Body1 className="AppFooterMobile__MiddleUpperBox__itemNavMobile">
                    {rightBoxLinks.termsConditions}
                  </Body1>
                </Link>
              </p>
              <p>
                <Link
                  to="/chinh-sach-bao-mat"
                  onClick={() => {
                    window.scrollTo(0, 0)
                    onButtonClick('/chinh-sach-bao-mat')
                    dispatch(setShopeeAppClicked(false))
                  }}
                >
                  <Body1 className="AppFooterMobile__MiddleUpperBox__itemNavMobile">
                    {rightBoxLinks.PrivacyPolicy}
                  </Body1>
                </Link>
              </p>
              <p style={{ marginTop: '15px' }}>
                <Link
                  to="/spaylater-dieu-khoan-su-dung"
                  onClick={() => {
                    window.scrollTo(0, 0)
                    onButtonClick('/spaylater-dieu-khoan-su-dung')
                    dispatch(setShopeeAppClicked(false))
                  }}
                >
                  <Body1 className="AppFooterMobile__MiddleUpperBox__itemNavMobile">
                    {rightBoxLinks.SPLTermsConditions}
                  </Body1>
                </Link>
              </p>
              <p style={{ marginTop: '15px' }}>
                <Link
                  to="/ung-tien-ngay-dieu-khoan-va-dieu-kien"
                  onClick={() => {
                    window.scrollTo(0, 0)
                    onButtonClick('/ung-tien-ngay-dieu-khoan-va-dieu-kien')
                    dispatch(setShopeeAppClicked(false))
                  }}
                >
                  <Body1 className="AppFooterMobile__MiddleUpperBox__itemNavMobile">
                    {rightBoxLinks.CashAdvanceTermsConditions}
                  </Body1>
                </Link>
              </p>
              <p style={{ marginTop: '15px' }}>
                <Link
                  to="/seasy-vay-tien-nhanh-dieu-khoan-su-dung"
                  onClick={() => {
                    window.scrollTo(0, 0)
                    onButtonClick('/seasy-vay-tien-nhanh-dieu-khoan-su-dung')
                    dispatch(setShopeeAppClicked(false))
                  }}
                >
                  <Body1 className="AppFooterMobile__MiddleUpperBox__itemNavMobile">
                    {rightBoxLinks.SEasyBuyerLoanTermsConditions}
                  </Body1>
                </Link>
              </p>
            </div>
          </div>
          <div className="AppFooterMobile__MiddleLowerBox">
            <p>{companyName}</p>
            <a
              href="http://online.gov.vn/nen-tang/c4c115a7-0e54-4d6a-b607-73ae719039ff"
              target="_blank"
              rel="noopener noreferrer"
              title="Đã xác nhận với Bộ Công Thương"
            >
              <img
                src={verifiedLabel}
                alt="Đã thông báo Bộ Công Thương"
                className="AppFooterMobile__MiddleLowerBox__verifiedLabel"
              />
            </a>
            <p>{address}</p>
            <p>{paymentServicesIntro}</p>
            {paymentServices.map((service, index) => (
              <p key={index}>{service}</p>
            ))}
          </div>
        </div>
      )}
    </>
  )
}
